import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "compare-table-pivot" }
const _hoisted_2 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_3 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_4 = { class: "table table-bordered table-hover" }
const _hoisted_5 = { class: "table-light" }
const _hoisted_6 = {
  scope: "col",
  class: "field-header"
}
const _hoisted_7 = {
  scope: "row",
  class: "field-name"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.records.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("i", {
            class: "fas fa-table",
            "aria-hidden": "true"
          }, null, -1),
          _createElementVNode("p", null, "Geen records gevonden", -1)
        ]))]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("table", _hoisted_4, [
            _cache[1] || (_cache[1] = _createElementVNode("caption", { class: "visually-hidden" }, " Kruistabel: elke rij is een kenmerk, elke kolom een project. ", -1)),
            _createElementVNode("thead", _hoisted_5, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.firstFieldLabel), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.records, (record) => {
                  return (_openBlock(), _createElementBlock("th", {
                    scope: "col",
                    key: record.id,
                    class: "record-header"
                  }, _toDisplayString(_ctx.formatValue(record[_ctx.displayFields[0]])), 1))
                }), 128))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayFields.slice(1), (field) => {
                return (_openBlock(), _createElementBlock("tr", { key: field }, [
                  _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.getFieldLabel(field)), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.records, (record) => {
                    return (_openBlock(), _createElementBlock("td", {
                      key: record.id,
                      class: "field-value"
                    }, _toDisplayString(_ctx.formatValue(record[field])), 1))
                  }), 128))
                ]))
              }), 128))
            ])
          ])
        ]))
  ]))
}